import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import GripperVertical from '@elliemae/ds-icons/GripperVertical';
import { DSIconSizes } from '@elliemae/ds-basic/Icon';

var DragControllerRow = function DragControllerRow(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'drag-controller' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? ['neutral', '500'] : _ref$color,
      _ref$icon = _ref.icon,
      Icon = _ref$icon === void 0 ? GripperVertical : _ref$icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? DSIconSizes.M : _ref$size,
      rest = _objectWithoutProperties(_ref, ["className", "color", "icon", "size"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, rest), /*#__PURE__*/React.createElement(Icon, {
    color: color,
    size: size
  }));
};

export default DragControllerRow;
//# sourceMappingURL=DragControllerRow.js.map
